import React from 'react';

import Cart from '@pkg/components/Cart/Cart';
import { useBreakpoints } from '@pkg/hooks';

import { useInteractionsStore } from '@app/store/zustand/interactions';

import { YatModalBottomSheet, YatModalSideSheet } from '../../primitives';

export const CartSidePanel = () => {
    const { cartOpen, toggleCartOpen } = useInteractionsStore();
    const { isMobile } = useBreakpoints();
    return (
        <div className="yat-picker__cart">
            {isMobile ? (
                <YatModalBottomSheet
                    open={cartOpen}
                    modalLabelId="yat-picker-cart-title"
                    closeCallback={toggleCartOpen}
                    scrollable={false}
                >
                    <Cart />
                </YatModalBottomSheet>
            ) : (
                <YatModalSideSheet
                    open={cartOpen}
                    side="right"
                    modalLabelId="yat-picker-cart-title"
                    closeCallback={toggleCartOpen}
                    scrollable={false}
                >
                    <Cart />
                </YatModalSideSheet>
            )}
        </div>
    );
};
